import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { TeamProvider } from '~/features/team/team-context';
import { PersonProvider } from '~/features/workspace/person/person-context';

/**
 * One person's page (web-redesign-03 phase 4; Decided 4): Information,
 * Access, Team and Activity, each a tab of its own address under one head.
 * Team's lists are read once here and shared by the four, as Team shares
 * them with its panel; another person starts a fresh page.
 */
function PersonLayout(): ReactElement {
  const { userId } = Route.useParams();
  return (
    <TeamProvider>
      <PersonProvider key={userId} userId={userId}>
        <Outlet />
      </PersonProvider>
    </TeamProvider>
  );
}

export const Route = createFileRoute('/_app/business/people/$userId')({ component: PersonLayout });
